var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1277",
    "data-name": "Group 1277",
    transform: "translate(-6029 -3015)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_551",
    "data-name": "Rectangle 551",
    width: 22,
    height: 22,
    transform: "translate(6029 3015)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g75"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1276",
    "data-name": "Group 1276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g77"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g79"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M6041.434,3033.929h-2.58a1.111,1.111,0,0,1-1.1-.931l-.139-.834a1.033,1.033,0,0,0-1.382-.8l-.792.3a1.109,1.109,0,0,1-1.354-.484l-1.29-2.236a1.111,1.111,0,0,1,.256-1.416l.653-.537a1.032,1.032,0,0,0,0-1.595l-.652-.539a1.109,1.109,0,0,1-.257-1.416l1.289-2.233a1.112,1.112,0,0,1,1.356-.485l.791.3a1.036,1.036,0,0,0,1.382-.8l.139-.835a1.111,1.111,0,0,1,1.1-.931h2.58a1.111,1.111,0,0,1,1.1.931l.139.835a1.035,1.035,0,0,0,1.382.8l.792-.3a1.108,1.108,0,0,1,1.354.484l1.29,2.234a1.109,1.109,0,0,1-.257,1.416l-.652.539a1.032,1.032,0,0,0,0,1.595l.652.537a1.11,1.11,0,0,1,.257,1.416l-1.289,2.235a1.117,1.117,0,0,1-1.354.486l-.793-.3a1.033,1.033,0,0,0-1.382.8l-.139.834A1.111,1.111,0,0,1,6041.434,3033.929Zm-4.834-3.629a2.037,2.037,0,0,1,2,1.7l.139.834a.112.112,0,0,0,.111.095h2.58a.113.113,0,0,0,.111-.095l.14-.834a2.031,2.031,0,0,1,2.718-1.569l.792.3a.121.121,0,0,0,.139-.051l1.289-2.234a.113.113,0,0,0-.027-.144l-.652-.537a2.033,2.033,0,0,1,0-3.139l.653-.538a.114.114,0,0,0,.026-.145l-1.29-2.233a.111.111,0,0,0-.137-.05l-.793.3a2.032,2.032,0,0,1-2.718-1.569l-.14-.835a.113.113,0,0,0-.111-.095h-2.58a.112.112,0,0,0-.111.095l-.139.835a2.034,2.034,0,0,1-2.719,1.57l-.792-.3a.114.114,0,0,0-.138.05l-1.29,2.233a.114.114,0,0,0,.026.145l.653.538a2.033,2.033,0,0,1,0,3.139l-.653.537a.114.114,0,0,0-.026.144l1.29,2.235a.116.116,0,0,0,.139.049l.791-.3A2.015,2.015,0,0,1,6036.6,3030.3Zm3.544-1.2a2.912,2.912,0,1,1,2.912-2.912A2.915,2.915,0,0,1,6040.144,3029.1Zm0-4.824a1.912,1.912,0,1,0,1.912,1.912A1.914,1.914,0,0,0,6040.144,3024.28Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon-settings.d356a48f37eb0f91d9af82ade8a78882.svg";
export { ForwardRef as ReactComponent };